import * as Styled from './styles'

export default function Subtitle({ children }) {
  return <Styled.Subtitle>{children}</Styled.Subtitle>
}
